import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, OnInit, Input } from '@angular/core';

/**
 * ColorCardComponent
 *
 * @export ColorCardComponent
 */
@Component({
  selector: 'app-color-card',
  templateUrl: './color-card.component.html',
  styleUrls: ['./color-card.component.scss'],
  animations: [
    trigger('color', [
      state('*', style({ backgroundColor: '#16A2B8' })),
      state('true', style({ backgroundColor: '#27A744' })),
      state('false', style({ backgroundColor: '#DB3445' })),
      transition('* => true', [animate('0.5s')]),
      transition('* => false', [animate('0.5s')]),
    ]),
  ],
})
export class ColorCardComponent implements OnInit {
  /**
   * Current animation state
   */
  @Input() state: string;

  /**
   * Input for the starting colour for animation transition
   */
  @Input() startColor: string;

  /**
   * Input for the ending colour for animation transition
   */
  @Input() endColor: string;

  /**
   * Creates an instance of ColorCardComponent.
   */
  constructor() {}

  /**
   * Does nothing
   */
  ngOnInit() {}
}
